<template>
  <div class="sharing-modal-wrapper">
    <modal ref='modal' class="sharing-modal">
      <template #header>
        <h5 class="modal-title mt-0">
          <img src="../../assets/shared.svg"/>
          {{ $t('share_invite.share_with') }} <b>{{ $t('share_invite.selected_folders') }}</b> {{ $t('share_invite.with_others') }}
        </h5>
      </template>

      <template #body>
        <form @submit.prevent='submit'>
          <div class='modal-body'>
            <div v-if="unverifiedUser" class="unverified-info">
              <p>
                {{ $t('verify.info_send_1') }} <strong> {{ $t('verify.info_send_2') }}  </strong> {{ $t('verify.info_share_3') }}
                <br>
                {{ $t('verify.info_part_2') }}
              </p>
            </div>
            <div class="new-sharing-options">
              <div class="sharing-with-contact">
                <p class="info"> <i class="fas fa-info-circle"></i>
                  {{ $t('share_invite.sharing_info', {folders: folderIds.length}) }}
                </p>
                <div class='form-group'>
                  <label>{{ $t('share_invite.invite_people') }}</label>
                  <div class='custom-select permission-select' @click.prevent='opened = true' v-click-outside='closeSelect'>
                    <input type='hidden' name='share_invite[invite_type]' :value='invite.type' />

                    <input type='text' :value='invite.label' class="invite-type" readonly />

                    <ul v-show='opened' class='options-list'>
                      <li @click.prevent="setReadMode()" :class="{ 'selected': invite.type === 'read'}">
                        <i class="fas fa-check"></i>
                        <span class="title">{{ $t('share_invite.those_selected_below') }}
                          <strong>{{ $t('share_invite.can_read') }}</strong>
                        </span>

                        <span class="descr">{{ $t('share_invite.view_info') }}</span>
                      </li>

                      <li @click.prevent="setWriteMode()" :class="{ 'selected': invite.type === 'write'}">
                        <i class="fas fa-check"></i>
                        <span class="title">{{ $t('share_invite.those_selected_below') }}
                          <strong>{{ $t('share_invite.can_edit') }}</strong>
                        </span>

                        <span class="descr">{{ $t('share_invite.write_info') }}</span>
                      </li>

                      <li @click.prevent="setAllMode()" :class="{ 'selected': invite.type == 'all'}">
                        <i class="fas fa-check"></i>
                        <span class="title">{{ $t('share_invite.those_selected_below') }}
                          <strong>{{ $t('share_invite.can_edit_folder_options') }}</strong>
                        </span>

                        <span class="descr">{{ $t('share_invite.edit_info') }}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class='form-group'>
                  <label class="label-contacts">{{ $t('share_invite.select_contacts') }}</label>
                  <multi-select :template='contactTemplate' :getter='getContacts' v-model='selectedContacts' name='share_invite[contact_ids][]' class="select-contact" />
                  <p class="sharing-note">{{ $t('share_invite.sharing_invite_note') }}</p>
                </div>

                <div class='form-group'>
                  <label>{{ $t('share_invite.add_mess') }}</label>
                  <textarea class="message-textarea" name='share_invite[message]' v-model='message'></textarea>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>

          <div class='modal-footer'>
            <i class="fas fa-circle-notch fa-spin" v-if="isProcessing"></i>
            <input type='submit' name='commit' :value="$t('share_invite.share')" :disabled='selectedContacts.length == 0 || folderIds.length == 0 || isProcessing || unverifiedUser' class='btn btn-primary'>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
  import _modal from '../_modal'
  import _multi_select from '../shared/_infinite_multi_select'

  export default {
    components: {
      modal: _modal,
      'multi-select': _multi_select,
    },
    created() {
      this.setReadMode()
    },
    data() {
      return {
        invite: {},
        opened: false,
        message: '',
        folderIds: [],
        selectedContacts: [],
        isProcessing: false,
      }
    },
    computed: {
      selectedContactIds() {
        return this.selectedContacts.map(c => c.id) || []
      },
    },
    methods: {
      open(folders) {
        this.folderIds = (folders || []).map(f => f.id)

        this.isProcessing = false
        this.selectedContacts = []
        this.invite = { type: 'read', label: this.$t('share_invite.selected_can_view') }
        this.message = ''

        this.$refs.modal.open()
      },
      close() {
        this.$refs.modal.close()
      },
      submit(e){
        if(this.folderIds.length > 1)
          this.submitBulk(e)
        else
          this.submitSingle(e)
      },
      getContacts(params) {
        return this.listStore.getContacts(params)
      },
      submitSingle(e){
        this.isProcessing = true

        const params = new FormData(e.target)

        const promises = this.folderIds.map(folderId => this.store.shareFolder(folderId, params))

        Promise.allSettled(promises).then(() => {
          this.store.sendMetrics({name: 'bulk_share_folder', params: this.$route.params, path: this.$route.fullPath})
          this.$toastr.success(this.$t('share_invite.folder_shared'))
          this.$emit('success')
          this.close()
        }).finally(() => {
          this.isProcessing = false
        })
      },
      submitBulk(e) {
        this.isProcessing = true

        const params = new FormData(e.target)
        this.folderIds.map(id => params.append('share_invite[folder_ids][]', id))

        this.axios.post(`/share_invites/bulk_create`, params)
            .then(response => {
              this.store.sendMetrics({name: 'bulk_share_folder', params: this.$route.params, path: this.$route.fullPath})
              this.$toastr.success(this.$t('share_invite.folder_shared'))
              this.$emit('success')
              this.close()
            })
            .catch(() => {
              this.isProcessing = false
            })
      },
      closeSelect() {
        this.opened = false
      },
      setReadMode() {
        this.invite = { type: 'read', label: this.$t('share_invite.selected_can_view') }
      },
      setWriteMode() {
        this.invite = { type: 'write', label: this.$t('share_invite.selected_can_edit') }
      },
      setAllMode() {
        this.invite = { type: 'all', label: this.$t('share_invite.can_edit_folder_options') }
      }
    }
  }
</script>

<style lang="sass">
  @import "../../styles/sharing_modal"

  .sharing-modal
    .side-slide-leave-active, .side-slide-enter-active
      transition: 1s

    .side-slide-enter
      transform: translate(100%, 0)

    .side-slide-leave-to
      transform: translate(-100%, 0)

    .modal-title img
      margin-right: 10px
  .invite-type
    border: none
    width: 100%
  .custom-select.select-contact
    width: 100%!important
    border: 1px solid #e8e8e8
  .permission-select
    position: relative
    .options-list
      border: 1px solid #ced4da
      border-top: none
      border-radius: 0 0 5px 5px
      background: #fff
      margin: 0
      padding: 5px 0 0
      list-style: none
      position: absolute
      z-index: 30
      top: 37px
      left: 0
      li
        cursor: pointer
        padding: 0 15px 10px
        i
          visibility: hidden
        &.selected
          background-color: #f2f2f2
          i
            visibility: visible
        &:hover
          background: #f2f2f2
        .descr
          display: block
          font-size: 12px
          padding-left: 28px
        .title
          padding-left: 10px
  .sharing-with-contact
    .info
      font-size: 14px
      background-color: #EBF4FE
      padding: 10px 7px
      border-radius: 3px
      font-weight: 500
      i
        font-size: 18px
        color: #5072ED
        vertical-align: middle
        margin-right: 5px
</style>
